import { Component, AfterViewInit } from '@angular/core';
import { MenuController } from '@ionic/angular';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements AfterViewInit {

  public static readonly sideMenuId = 'side-menu'; // In case of change, do the same in the template.

  constructor(
    private menuController: MenuController
  ){

  }
  
  public ngAfterViewInit(): void {
    this.menuController.enable(true, HomeComponent.sideMenuId);
  }

}
